import React from 'react';

/**
 * Reusable confirmation modal — replaces all window.confirm() calls.
 *
 * Props:
 *   isOpen       boolean
 *   onClose      () => void
 *   onConfirm    () => void
 *   title        string
 *   message      string | ReactNode
 *   confirmLabel string   — default "Confirm"
 *   danger       boolean  — red styling (default true)
 *   loading      boolean
 */
export default function ConfirmModal({
  isOpen, onClose, onConfirm,
  title = 'Confirm Action',
  message,
  confirmLabel = 'Confirm',
  danger = true,
  loading = false,
}) {
  if (!isOpen) return null;

  const accentColor = danger ? '#ef4444' : '#3b82f6';
  const accentBg = danger ? 'rgba(239,68,68,0.08)' : 'rgba(59,130,246,0.08)';

  return (
    <div style={{ position:'fixed', inset:0, zIndex:9990, display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div style={{ position:'absolute', inset:0, background:'rgba(0,0,0,0.5)' }} onClick={onClose} />
      <div style={{
        position:'relative', width:400, maxWidth:'94vw',
        background:'var(--bg-card, #111827)', border:`1px solid ${danger ? 'rgba(239,68,68,0.3)' : 'var(--border, #1e293b)'}`,
        borderRadius:12, boxShadow:'0 16px 48px rgba(0,0,0,0.5)', overflow:'hidden',
      }}>
        <div style={{ height:3, background:accentColor }} />
        <div style={{ padding:'20px 22px' }}>
          <div style={{ display:'flex', alignItems:'flex-start', gap:12, marginBottom:14 }}>
            <div style={{
              width:36, height:36, borderRadius:8, flexShrink:0,
              background:accentBg, display:'flex', alignItems:'center', justifyContent:'center',
              fontSize:'1.1rem',
            }}>
              {danger ? '!' : '?'}
            </div>
            <div>
              <div style={{ fontWeight:700, fontSize:'0.97rem', color:'var(--text-primary, #e2e8f0)', marginBottom:4 }}>
                {title}
              </div>
              {message && (
                <div style={{ fontSize:'0.86rem', color:'var(--text-muted, #94a3b8)', lineHeight:1.5 }}>
                  {message}
                </div>
              )}
            </div>
          </div>
        </div>
        <div style={{
          padding:'12px 22px', borderTop:'1px solid var(--border, #1e293b)',
          display:'flex', gap:8, justifyContent:'flex-end', background:'rgba(0,0,0,0.1)',
        }}>
          <button
            onClick={onClose}
            style={{
              background:'rgba(255,255,255,0.06)', border:'1px solid var(--border, #1e293b)',
              color:'var(--text-muted, #94a3b8)', padding:'7px 16px', borderRadius:8,
              cursor:'pointer', fontSize:'0.85rem', fontWeight:600, fontFamily:'inherit',
            }}
          >Cancel</button>
          <button
            onClick={onConfirm}
            disabled={loading}
            style={{
              background:accentColor, border:'none', color:'#fff',
              padding:'7px 18px', borderRadius:8, cursor: loading ? 'default' : 'pointer',
              fontSize:'0.85rem', fontWeight:700, fontFamily:'inherit',
              opacity: loading ? 0.6 : 1, transition:'opacity 0.15s',
            }}
          >{loading ? 'Processing...' : confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
